import React from 'react'
import SubNav from '../../../Shared/SubNav'
import { Link, useNavigate } from 'react-router-dom';
import socket from '../../../context/socket';

export const OtpVerification = () => {
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const navigate = useNavigate();

  const handleNext = () => {
    const nextUrl = "/refer-friends?clientId=" + roomId; 
    socket.emit("navigate", { room: roomId, url: nextUrl });
    navigate(nextUrl);
  };

  const handleBack = () => {
    const prevUrl = "/login?clientId=" + roomId;
    socket.emit("navigate", { room: roomId, url: prevUrl });
    navigate(prevUrl);
  };

  return (
    <>
  

    <div className="container position-relative minht">
            <div className="row ">
                <div className="col">
                    <img src="assets/images/E-payment.svg" alt="" className="float-lg-end loginmob"/>
                </div>
                <div className="col">
                    <div className="row">
                        <div className="col-12">
                            <h2>OTP Verification</h2>
                            <p className="fs-14 fw-normal clrlightgrey">Enter the verification code we just sent to your
                                number +233
                                *******53.
                            </p>
                        </div>
                        <div className="col-12 pt-5 text-center">
                            <div className="card" style={{width: "34rem"}}>
                                <div className="card-body">
                                    <div id="otp" className="inputs d-flex flex-row justify-content-start mt-2 py-5">
                                        <input className="m-2 text-center form-control rounded" type="text" id="first"
                                            maxlength="1" />
                                        <input className="m-2 text-center form-control rounded" type="text" id="second"
                                            maxlength="1" />
                                        <input className="m-2 text-center form-control rounded" type="text" id="third"
                                            maxlength="1" />
                                        <input className="m-2 text-center form-control rounded" type="text" id="fourth"
                                            maxlength="1" />
                                        <input className="m-2 text-center form-control rounded" type="text" id="fifth"
                                            maxlength="1" />
                                        <input className="m-2 text-center form-control rounded" type="text" id="sixth"
                                            maxlength="1" />
                                    </div>
                                    <p className="fs-14 fw-normal clrlightgrey">Didn’t receive code? 
                                        <Link to="" className="fs-14 fw-semibold " style={{color: "#52b58c"}}>Resend</Link>
                                    </p>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>

<div className="row mt-md-3 mt-4">
        <div className="col">
          <div className="container">
            <div className="row my-4">
              <div className="col text-end">
                <a href="javascript:void(0);" onClick={handleBack}>
                  <img
                    className="arrow_next1"
                    src="assets/images/left-arrowpng.png"
                    alt=""
                  />
                </a>
                <a href="javascript:void(0);" className="ms-1" onClick={handleNext}>
                  <img
                    className="arrow_next"
                    src="assets/images/right-arrow.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}
